<button
  type="button"
  class="a-btn"
  [class.a-btn--disabled]="loading"
  [disabled]="loading"
  [attr.aria-busy]="loading ? 'true' : null"
  (click)="onClick()">
  <svg class="a-btn__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M14.94 10.62c-.02-2.06 1.68-3.05 1.76-3.1-.96-1.4-2.45-1.59-2.99-1.61-1.27-.13-2.49.75-3.13.75-.66 0-1.65-.74-2.71-.72-1.39.02-2.69.81-3.4 2.06-1.46 2.52-.37 6.24 1.03 8.28.69 1 1.5 2.12 2.56 2.08 1.04-.04 1.43-.66 2.68-.66 1.25 0 1.6.66 2.7.64 1.12-.02 1.82-1.01 2.5-2.02.8-1.16 1.13-2.29 1.14-2.35-.02-.01-2.18-.84-2.2-3.33zM12.9 4.56c.56-.69.94-1.65.83-2.6-.81.04-1.79.55-2.37 1.23-.52.6-.97 1.58-.85 2.51.91.07 1.83-.46 2.39-1.14z"
      fill="#000" />
  </svg>
  <span class="a-btn__label">{{ label }}</span>
</button>
